export default __webpack_public_path__ + "static/media/05_prove_it.082447db.jpg";